module.exports = __webpack_public_path__ + "static/media/logo.ac7efeae.webp";